// extracted by mini-css-extract-plugin
module.exports = {"box":"greenheader_box__5oL3l","word":"greenheader_word__3iiZr"};